var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ServiceInfo(_a) {
    var children = _a.children;
    return (_jsx("section", __assign({ className: "w-full max-w-[856px] py-4 px-4 bg-light-blue-100 flex flex-col gap-4 rounded-lg" }, { children: children })));
}
export function ServiceInfoItem(_a) {
    var title = _a.title, content = _a.content, _b = _a.listType, listType = _b === void 0 ? "ordered" : _b;
    return (_jsxs("div", __assign({ className: "text-black-900" }, { children: [_jsx("h6", __assign({ className: "text-sm font-medium sm:text-base" }, { children: title })), listType === "ordered" ? (_jsx("ol", __assign({ className: "list-decimal font-light" }, { children: content.map(function (item, idx) { return (_jsx("li", __assign({ className: "ml-4 text-xs sm:text-sm" }, { children: item }), "ol-item-" + idx + item.slice(0, 3))); }) }))) : listType === "unordered" ? (_jsxs("ul", __assign({ className: "list-disc font-light" }, { children: [content.map(function (item, idx) { return (_jsx("li", __assign({ className: "ml-4 text-xs sm:text-sm" }, { children: item }), "ul-item-" + idx + item.slice(0, 3))); }), " "] }))) : (_jsx("p", __assign({ className: "font-light m-0 text-xs sm:text-sm" }, { children: content })))] })));
}
